<template>
  <div :class="['mx-toolbar']">
    <div class="flex flex-wrap px-4" >
      <template v-for="section in toolbar">
        <div class="flex items-center h-6 mr-2 whitespace-nowrap mx-toolbar-section">
          <div class="text-sm tool-section-name">{{ section.name }}：</div>
          <div class="flex flex-1 tool-section">
            <div v-for="tool in section.children" class="grid" >
              <a v-if="tool.type === 'dropdown'" :class="[getToolbarItemClassName(tool.key), 'grid', 'm-auto']"
                :title="tool.tip || tool.key"  style="cursor: pointer;margin: 2px; ">
                <el-dropdown :disabled="disabledDrapdownComputed[`dropdown_${tool.key}`]" trigger="click" class="m-auto">
                  <span v-if="tool.iconType === 'iconfont'" :class="getToolbarClassName(tool.icon as string)"></span>
                  <img v-else-if="tool.iconType === 'image'" :src="(tool.icon as string)" />
                  <span v-else> {{ tool.name }}</span>
                  <template #dropdown>
                    <el-dropdown-menu>
                      <el-dropdown-item v-for="dItem in tool.children"
                        @click="handleCommand(tool, dItem)">
                        <span v-if="tool.iconType === 'iconfont'"
                          :class="[getToolbarClassName(dItem.icon as string), 'dropdown-item-icon']"></span>
                        <img v-else-if="tool.iconType === 'image'" :src="(dItem.icon as string)"
                          class="dropdown-item-icon" />
                        <span v-else class="dropdown-item-icon"> {{ dItem.name }}</span>
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </template>
                </el-dropdown>
              </a>
              <a v-else :class="getToolbarItemClassName(tool.key)" @click="handleToolbarItemClick(tool.key)" :title="tool.tip || tool.key"
                style="cursor: pointer;margin: 2px; ">
                <span v-if="tool.iconType === 'iconfont'" :class="getToolbarClassName(tool.icon as string)"></span>
                <img v-else-if="tool.iconType === 'image'" :src="(tool.icon as string)" />
                <span v-else> {{ tool.name }}</span>
              </a>
            </div>
          </div>
        </div>
      </template>
    </div>
    <!-- <div class="mx-toolbar_folder" @click="handleChangeToolbarFolder">
      <el-icon>
        <ArrowUp />
      </el-icon>
    </div> -->
  </div>
</template>
<script lang="ts">
export default {
  name: 'Toolbar'
}
</script>
<script setup lang="ts">
interface ToolbarProps {
  graph?: _VTI_TYPE_MyGraph
  toolbar?: iToolbarSection[]
}
import { nextTick, onMounted, ref, computed, ComputedRef } from 'vue'
import MyGraph from './graph'
import '../assets/icons/iconfont.css'
import { ElIcon } from 'element-plus'
import { ArrowUp } from '@element-plus/icons-vue'
import { iToolbarSection, iToolbarItem, IType, iToolbarItemDropdown } from './type/type'
const props = defineProps<ToolbarProps>()
const toolbar = ref<iToolbarSection[]>([
  // {
  //   name: '默认', children: [
  //     { key: 'undo', name: 'undo', type: 'default' },
  //     { key: 'redo', name: 'redo', type: 'default' },
  //     { key: 'zoomIn', name: 'zoomIn', type: 'default' },
  //     { key: 'zoomOut', name: 'zoomOut', type: 'default' },
  //     { key: 'delete', name: 'delete', type: 'default' },
  //   ]
  // },
  // { name: '', children: [] },
])
//drowdown有选中时关闭禁用
const disabledDrapdownComputed = ref<{[property:string]:boolean}>({})
// const isFold = ref(false)
const disabled = (key: string) => {
  return `toolbar_item  cursor-pointer text-center leading-8 cursor-not-allowed opacity-20 ${key}`
}
const normal = (key: string) => {
  return `toolbar_item  cursor-pointer text-center leading-8 hover:bg-slate-200 opacity-100 ${key}`
}
const handleCommand = (tool: iToolbarItem, item:iToolbarItemDropdown) => {
  // console.log(tool.name,command)
  tool.name = item.name
  tool.value = item.value
  tool.icon = item.icon
  const toolitem = JSON.parse(JSON.stringify(item))
  if(tool.iconType){
    toolitem.iconType = tool.iconType
  }
  handleToolbarItemClick(tool.key,{
    config:toolbar.value,
    current:toolitem
  })
}
// const handleChangeToolbarFolder = () => {
//   isFold.value = !isFold.value
// }
onMounted(() => {
  nextTick(() => {
    //合并重复section
    let reflectAny: IType<iToolbarItem[]> = {}
    if (props.toolbar) {
      props.toolbar.forEach(v => {
        if (Object.hasOwn(reflectAny, v.name)) {
          reflectAny[v.name].push(...v.children)
        } else {
          reflectAny[v.name] = v.children
        }
      })
    }
    let arr = Object.entries(reflectAny)
    if (arr.length > 0) {
      //合并重复工具名称，目前是使用第一个
      //发现问题，跨section名称相同会有影响，所有应该先处理所有的children，待修复
      toolbar.value = arr.map(v => {
        let children = v[1] as iToolbarItem[]
        let nameRecord: string[] = []
        let targetarr: iToolbarItem[] = []
        for (let c of children) {
          if (nameRecord.indexOf(c.key) === -1) {
            nameRecord.push(c.key)
            targetarr.push(c)
          }
        }
        return {
          name: v[0],
          children: targetarr
        }
      })
    }
    toolbar.value.forEach((tool, index) => {
      tool.children.forEach(v => {
        const key = v.key
        const action = props.graph?.actions.get(key)
        if(v.type==='dropdown'){
          const enabled = action?.isEnabled()
          disabledDrapdownComputed.value[`dropdown_${key}`] =!enabled
          console.log(disabledDrapdownComputed.value)
          }
        action?.addListener('stateChanged', () => {
          const enabled = action.isEnabled()
          const container  = document.querySelector(`.mx-toolbar`)
          const dom = container?.querySelector(`.${key}`)
          if (dom) {
            if (enabled) {
              dom.className = normal(key)
            } else {
              dom.className = disabled(key)
            }
          }
          if(v.type==='dropdown'){
            disabledDrapdownComputed.value[`dropdown_${key}`] =!enabled
            console.log(disabledDrapdownComputed.value)
          }
        })
      })
    })
  })
})
const getToolbarItemClassName = (key: string) => {
  const action = props.graph?.actions.get(key)
  console.log(action,action?.enabled)
  return action?.enabled ? normal(key) : disabled(key)
}
const getToolbarClassName = (key: string) => {
  return `toolbar_sprite iconfont icon-${key}`
}
const handleToolbarItemClick = (key: string, params: any = {}) => {
  const action = props.graph?.actions.get(key)
  if (action?.enabled) {
    action.func(props.graph as MyGraph,params)
  }
  // action!.func(props.graph as MyGraph,params)
}
</script>

<style lang="scss">
.mx-toolbar {
  position: relative;
  overflow: visible;
  user-select: none;
  &.toolbar-fold {
    min-height: 1.5rem;
  }
  .mx-toolbar-section{
    padding: 1rem 0;
    box-sizing: content-box;
  }
  .toolbar {
    width: 100%;
    height: 24px;
    border-bottom: 1px solid #dadce0;
    user-select: none;
  }
  .tool-section-name{
    color: #666666;
  }
  .tool-section{
    background-color:#F7F7F7;
    display: flex;
    align-items: center;
    border-radius: 4px;
  }
  .toolbar_item .toolbar_sprite {
    height: 20px;
    display: grid;
    width: 20px;
  }

  .mx-toolbar_folder {
    position: absolute;
    right: 0;
    bottom: 0;
  }

  .el-dropdown {
    .el-tooltip__trigger {
      outline: none;
    }
  }

  .toolbar_item {
    height: 24px;
    min-width: 1.5rem;
    display: grid;
    place-content: center;
  }

  .toolbar_item {

    span,
    img {
      display: inline-block;
      height: 20px;
      display: grid;
      place-content: center;
    }
  }
}

.toolbar-fold {
  .mx-toolbar_folder {
    position: absolute;
    height: 1.5rem;
    width: 1.5rem;
    right: 0;
    top: 50%;
    transform: translate(0, -50%) rotate(180deg);
  }
}

.el-divider {

  &.el-divider--vertical {
    height: auto !important;
  }
}

.el-dropdown-menu__item {
  .dropdown-item-icon {
    height: 1.2rem;
  }
}</style>
